import {
  FormControl, FormControlLabel, Radio, RadioGroup,
} from '@mui/material';
import type { PropsWithChildren } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

interface InstrumentsDetectionWrapperProps extends PropsWithChildren {
  handleRadioChange: (detection: boolean) => void;
  showRadios: boolean;
  children: React.ReactNode;
}

const InstrumentsDetectionWrapper: React.FC<InstrumentsDetectionWrapperProps> = ({
  handleRadioChange,
  showRadios,
  children,
}) => {
  const [detection, setDetection] = React.useState('false');
  const { t } = useTranslation();

  const handleChange = (_event: any, value: string) => {
    setDetection(value);
    handleRadioChange(JSON.parse(value));
  };
  if (showRadios) {
    return (
      <FormControl>
        <RadioGroup onChange={handleChange} value={detection} name="radio-buttons-group">
          <FormControlLabel
            value="false"
            control={<Radio />}
            label={t('home.input.dialog.choose_instrument.select_instrument')}
          />
          <div>{children}</div>
          <FormControlLabel
            value="true"
            control={<Radio />}
            label={t('home.input.dialog.choose_instrument.detect_instrument')}
          />
        </RadioGroup>
      </FormControl>
    );
  }
  return <div>{children}</div>;
};

export default InstrumentsDetectionWrapper;
